import script from "./SubformDarkView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubformDarkView.vue?vue&type=script&setup=true&lang=js"

import "./SubformDarkView.vue?vue&type=style&index=0&id=6103a6df&lang=scss"

const __exports__ = script;

export default __exports__